import React from 'react';

// Base pulsing placeholder block. Use for any bespoke loading shape; the
// composed variants below cover the two most common cases (a table of rows,
// a grid of cards) so pages don't have to hand-roll skeleton markup.
export const Skeleton = ({ className = '' }) => (
  <div className={`animate-pulse bg-slate-200 dark:bg-slate-700 rounded-md ${className}`} aria-hidden="true" />
);

export const TableSkeleton = ({ rows = 5, columns = 4 }) => (
  <div className="w-full" role="status" aria-label="Loading table data">
    <div className="hidden sm:flex gap-4 px-4 py-3.5 border-b border-slate-200/60 dark:border-slate-700">
      {Array.from({ length: columns }).map((_, i) => (
        <Skeleton key={i} className="h-3 flex-1" />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <div key={rowIdx} className="flex gap-4 px-4 py-4 border-b border-slate-100 dark:border-slate-800">
        {Array.from({ length: columns }).map((_, colIdx) => (
          <Skeleton key={colIdx} className="h-4 flex-1" />
        ))}
      </div>
    ))}
  </div>
);

export const CardSkeleton = ({ count = 3, className = '' }) => (
  <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 ${className}`} role="status" aria-label="Loading content">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 p-5 space-y-3">
        <Skeleton className="h-10 w-10 rounded-xl" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    ))}
  </div>
);

export default Skeleton;
